@import '../../../theme.scss';

verdocs-component-error {
  font-family: $verdocs-primary-font;
  display: flex;
  padding: 15px;
  align-items: center;
  justify-content: center;

  .inner {
    flex: 1;
    height: 300px;
    display: flex;
    font-size: 18px;
    box-sizing: border-box;
    padding: 0 20px;
    background: #ffffff;
    align-items: center;
    justify-content: center;
  }
}
